<template>
  <div v-if="historic.length > 0" class="dass-container-history">
    <div class="dass-historic">
      <horizontal-timeline
        :past-and-current-items="historicCurrent"
        :future-items="timelineFuture"
      />    
    </div>
  </div>
  <div v-else>{{ $t('erro.semDados') }}</div>
</template>
<script>
import { mapGetters } from 'vuex'
import HorizontalTimeline from './HorizontalTimeline.vue'

export default {
  name: 'history',  
  components: {
    HorizontalTimeline
  },
  data() {
    return {
      showHistoryList: [],
    }
  },
  computed: {
    ...mapGetters('protocol_detail', { historic: 'getHistory', protocol: 'getProtocol', timeline: 'getTimeline' }),
    historicCurrent() {
      return this.historic.map((history) => {
        return {
          ...history,
          label: this.$t(`situacoes.${history.SIT_ID}`),
          date: history.PHS_DATA
        }
      })
    },
    timelineFuture() {
      return this.timeline.map((history) => {
        return {
          ...history,
          label: this.$t(`situacoes.${history.SIT_ID_NEW}`),
        }
      })
    }
  },
  methods: {
    showHistory: function (index, sitId) {      
      const key = `${sitId}_${index}`
      this.showHistoryList[key] = !this.showHistoryList[key]
    },
    currentStatusShow: function () {
      const statusProtocol = this.protocol.SIT_ID      
      const currentIndex = this.historic.findLastIndex((history) => history.SIT_ID === statusProtocol)
     
      if (currentIndex !== -1) {
        this.showHistory(currentIndex, this.historic[currentIndex].SIT_ID)
      }
    },
  },  
  updated() {
    this.$nextTick(() => {
      this.currentStatusShow()
    })
  },
}
</script>

<style lang="scss">
.dass-container-history {
  .dass-historic {   
    width: 100%;   
    padding-left: var(--space__2x);
    padding-right: var(--space__2x);
    @media (max-width: 1024px) {
      padding-left: var(--space);
      padding-right: var(--space);
    }
  }
}
</style>
